import React from 'react';
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import './GGToolTip.scss';

interface GGToolTipProps {
    title: string;
    body: string;
    children: React.ReactElement;
}

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        minWidth: 400,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
        padding: '1rem',
    },
}));

const GGToolTip: React.FC<GGToolTipProps> = ({ children, title, body }) => {
    return (
        <HtmlTooltip placement='top-start' className='html-tooltip' 
        title= 
        { <React.Fragment>
            <Typography className='tooltip-title' color="inherit">{title}</Typography>
            <Typography className='tooltip-body' color="inherit">{body}</Typography>
         </React.Fragment>}>
            {children}
        </HtmlTooltip>
    );
};

export default GGToolTip;